import Cookies from 'js-cookie';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '~/selectors/user';

const COOKIE_NAME = 'sharedLinkAccessEmail';

export const useSharedLinkAccessEmail = () => {
  const user = useSelector(selectUser);
  const userEmail = user?.email ?? null;

  const [accessEmail, setAccessEmail] = useState<string | null>(() => {
    const cookie = Cookies.get(COOKIE_NAME);
    return cookie ?? null;
  });

  const updateAccessEmail = useCallback(
    (email: string) => {
      Cookies.set(COOKIE_NAME, email);
      setAccessEmail(email);
    },
    [setAccessEmail],
  );

  const removeAccessEmail = useCallback(() => {
    Cookies.remove(COOKIE_NAME);
    setAccessEmail(null);
  }, [setAccessEmail]);

  useEffect(() => {
    userEmail && updateAccessEmail(userEmail);
  }, [userEmail, updateAccessEmail]);

  return {
    accessEmail,
    updateAccessEmail,
    removeAccessEmail,
  };
};
